import classes from './ScoreGraph.module.css'
import AveragingScore from '../../../../../lms-shared/StudentStatistics/AveragingScore'
import { useSelector } from 'react-redux';

const AverageStudentGrades = ({ studentsSubmmissionList }) => {
    const texts = useSelector(state => state.translate.texts);

    const studentsWithScoredAverage = studentsSubmmissionList.students.filter(user => user.studentScoreAverage)
    const avergeScore = studentsWithScoredAverage.reduce((total, next) => total + next.studentScoreAverage, 0) / studentsWithScoredAverage.length;
    return (
        <div className={classes.ChartSize}>
            <AveragingScore avergeScore={avergeScore ? Math.round(avergeScore * 100) : null} titleText={texts.studentsAverageScore}></AveragingScore>
        </div>
    )
}
export default AverageStudentGrades